module.exports = __webpack_public_path__ + "img/b38.a0029170.jpeg";